import { createSelector, defaultMemoize as memoize } from 'reselect';

import { numberFromString } from 'lib/number';
import { dateFromString } from 'lib/date';
import { getQueryParams } from 'store/router/routerSelectors/getQueryParams';

const memoizedCheckInDateFromString = memoize(dateFromString);
const memoizedCheckOutDateFromString = memoize(dateFromString);

export const getQuery = createSelector(
  getQueryParams,
  ({ checkIn, checkOut, adults, children, infants, roomTypeId, propertyId, offerId }) => ({
    roomTypeId,
    propertyId,
    offerId,
    checkIn: memoizedCheckInDateFromString(checkIn),
    checkOut: memoizedCheckOutDateFromString(checkOut),
    adults: numberFromString(adults),
    children: numberFromString(children),
    infants: numberFromString(infants),
  }),
);
